module.exports = __webpack_public_path__ + "media/reskin-images/icon--hamburger-menu-48286502.svg";